<template>
    <div>
        <div class="popup-background" v-if="internalShowPopup"></div>
        <div class="popup" v-if="internalShowPopup">
            <mu-row class="popup-content h-100">
                <mu-col span="6" sm="6" class="h-100 pop-text">
                    <div class="mt-3">
                        <span class="pop-title" v-html="$tc('pop_up.title')"></span>
                    </div>
                    <div class="mt-1 mb-4">
                        <span class="pop-subtitle">{{ $t('pop_up.subtitle') }}</span>
                    </div>
                    <div>
                        <mu-button color="#46A6FF" round class="pop-button text-center px-2" @click="downloadApp()">
                            {{ $t('pop_up.button') }}
                        </mu-button>
                    </div>
                </mu-col>
                <mu-col span="6" sm="6" class="shadow-img h-100">
                    <span class="close" @click="closePopup">&times;</span>
                    <img src="/images/pop_up/vallarta_app.png" alt="" class="image-app">
                </mu-col>
            </mu-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showPopup: {
            type: Boolean,
        },
    },
    data() {
        return {
            internalShowPopup: this.showPopup,
        };
    },
    methods: {
        closePopup() {
            this.internalShowPopup = false;
        },
        getDevice() {
            let user_agent = navigator.userAgent || navigator.vendor || window.opera;
            let sys = navigator.platform;

            if (/windows phone/i.test(user_agent)) {
                return "Windows";
            } else if (/android/i.test(user_agent)) {
                return "Android";
            } else if (/iPad|iPhone|iPod/.test(user_agent) && !window.MSStream) {
                return "iOS";
            } else if (sys.indexOf("Win") == 0) {
                return "Windows";
            } else if (sys.indexOf("Mac") == 0) {
                return "Mac";
            } else if (sys.indexOf("X11") == 0 || sys.indexOf("Linux") == 0) {
                return "Linux";
            } else {
                return "none";
            }
        },
        downloadApp() {
            const device = this.getDevice()
            let link = null
            if (device == 'iOS') {
                link = 'https://apps.apple.com/mx/app/vallartaplus/id1459155307?mt=8'
            }
            else if (device == 'Android') {
                link = 'https://play.google.com/store/apps/details?id=com.vallartaplus.vallartaplus'
            }

            if (link != null) {
                window.open(link, '_blank');
            }
        }
    },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Krub:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&family=League+Spartan:wght@100..900&display=swap');
.popup-background {
    position: fixed;
    left: 0;
    top: 0;
    width: 428px;
    height: 221px;
    z-index: 998;
    pointer-events: none;
}

.popup {
    position: fixed;
    bottom: 35px;
    left: 50%;
    transform: translate(-50%);
    background-color: #fff;
    width: 428px;
    height: 221px;
    z-index: 999;
    border-radius: 21px;
}

.pop-text{
    padding: 20px !important;
}

.popup-content {
    position: relative;
}

.close {
    position: absolute;
    top: 7px;
    right: 13px;
    cursor: pointer;
    display: block;
}


.pop-title {
    font-family: "League Spartan", sans-serif;
    font-weight: 700;
    font-size: 30px;
    color: #46A6FF;
    line-height: normal;
}

.pop-subtitle {
    font-family: "Krub", sans-serif;
    font-weight: 500;
    font-size: 13px;
    color: #46A6FF;
}

.pop-button {
    width: 174px;
    height: 27px;
    font-family: "Krub", sans-serifn !important;
    font-weight: 300;
    font-size: 15px;
    color: white;
    text-transform: none;
}

.shadow-img {
    background: linear-gradient(70deg, #3e5d6b, #799FB2);
    border-radius: 0px 21px 21px 0px;
}

.image-app{
    width: 155px;
    position: fixed;
    bottom: 0px;
    right: 6%;
}

@media (max-width: 576px) {
    .popup {
        position: fixed;
        bottom: 50px;
        left: 50%;
        transform: translate(-50%);
        background-color: #fff;
        width: 400px;
        z-index: 999;
        border-radius: 21px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }

    .pop-text {
        padding: 15px !important;
    }

    .shadow-img {
        background: linear-gradient(70deg, #3e5d6b, #799FB2);
        border-radius: 0px 21px 21px 0px;
    }

    .image-app {
        width: 155px;
        position: fixed;
        bottom: 0px;
        right: 6%;
    }

    .pop-button {
        width: 174px;
        height: 27px;
        font-family: "Krub", sans-serifn !important;
        font-weight: 300;
        font-size: 15px;
        color: white;
        text-transform: none;
    }
}

@media (max-width: 420px) {
    .popup {
        position: fixed;
        bottom: 50px;
        left: 50%;
        transform: translate(-50%);
        background-color: #fff;
        width: 300px;
        z-index: 999;
        border-radius: 21px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }

    .pop-text {
        padding: 15px !important;
    }

    .shadow-img {
        background: linear-gradient(70deg, #3e5d6b, #799FB2);
        border-radius: 0px 21px 21px 0px;
    }

    .image-app {
        width: 115px;
        position: fixed;
        bottom: 0px;
        right: 5%;
    }

    .pop-button {
        width: 120px;
        height: 22px;
        font-family: "Krub", sans-serifn !important;
        font-weight: 300;
        font-size: 11px;
        padding: 0px !important;
        color: white;
        text-transform: none;
    }
}

@media (max-width: 300px) {
    .popup {
        position: fixed;
        bottom: 50px;
        left: 50%;
        transform: translate(-50%);
        background-color: #fff;
        width: 280px;
        height: 200px;
        z-index: 999;
        border-radius: 21px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }

    .pop-text {
        padding: 13px !important;
    }

    .shadow-img {
        background: linear-gradient(70deg, #3e5d6b, #799FB2);
        border-radius: 0px 21px 21px 0px;
    }

    .pop-title {
        font-size: 25px;
        line-height: normal;
    }

    .pop-subtitle {
        font-size: 11.5px;
    }


    .image-app {
        width: 115px;
        position: fixed;
        bottom: 0px;
        right: 5%;
    }

    .pop-button {
        width: 120px;
        height: 22px;
        font-family: "Krub", sans-serifn !important;
        font-weight: 300;
        font-size: 11px;
        padding: 0px !important;
        color: white;
        text-transform: none;
    }
}
</style>
